import DeviceUtilities from '../utils/device';
import React from 'react';

const DeviceInfo = React.createContext(DeviceUtilities.getDeviceInfo());

export default DeviceInfo;
